module.exports = __webpack_public_path__ + "img/西安飞瑞.254582d.png";